import { SecurityRuleFactory, createSimpleClaimRule } from "../auth-rules";

export type IsTesterClaimType = string | string[];
export type IsTesterClaimTyåe = IsTesterClaimType;
export type IsTesterClaimArgs = {};

export const ruleIsTester: SecurityRuleFactory<IsTesterClaimType, IsTesterClaimArgs> =
  createSimpleClaimRule<IsTesterClaimType, IsTesterClaimArgs>("tester");

